import React from 'react';

export const DirtyContext = React.createContext({
  getPageLevelDirty: () => {},
  setPageLevelDirty: () => {},
  history: {},
});



// WEBPACK FOOTER //
// ./src/components/tracked/DirtyContext.js